import React from 'react';
import PropTypes from 'prop-types';
import { HeaderComponent } from './HeaderComponent';

const HeaderContainer = ({
  title,
  subtitle,
  period,
  learnMore,
  modalContent,
  buttonTitle,
  pathname,
  buttonTrackEvent,
  tooltipIcon,
  tooltipText,
  tooltipTrackEvent,
  idTest,
  hasModalWithAccordion,
  accordionData,
}) => {
  return (
    <HeaderComponent
      title={title}
      subtitle={subtitle}
      period={period}
      learnMore={learnMore}
      modalContent={modalContent}
      buttonTitle={buttonTitle}
      buttonTrackEvent={buttonTrackEvent}
      pathname={pathname}
      tooltipIcon={tooltipIcon}
      tooltipText={tooltipText}
      tooltipTrackEvent={tooltipTrackEvent}
      idTest={idTest}
      hasModalWithAccordion={hasModalWithAccordion}
      accordionData={accordionData}
    ></HeaderComponent>
  );
};

HeaderContainer.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  period: PropTypes.string,
  buttonTitle: PropTypes.string.isRequired,
  buttonTrackEvent: PropTypes.func,
  tooltipTrackEvent: PropTypes.func,
  pathname: PropTypes.string,
  tooltipIcon: PropTypes.string,
  tooltipText: PropTypes.string,
  idTest: PropTypes.string,
  learnMore: PropTypes.string,
  cardContent: PropTypes.object,
  hasModalWithAccordion: PropTypes.bool,
  accordionData: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.string,
  })),
};

export { HeaderContainer };
